import {
	SYSTEM_EVENTS_LOGBOOK_ACTION_TYPES,
	SystemEventsLogbookActions,
	SystemEventsLogbookState,
} from '../../../../types/systemEvent'
import dayjs from 'dayjs'

const initialState: SystemEventsLogbookState = {
	timeRange: [
		dayjs().subtract(6, 'd').startOf('day').valueOf(),
		dayjs().endOf('day').valueOf(),
	],
	events: [],
	filter: [],
}

export default (
	state = initialState,
	action: SystemEventsLogbookActions
): SystemEventsLogbookState => {
	switch (action.type) {
		case SYSTEM_EVENTS_LOGBOOK_ACTION_TYPES.LOGBOOK_CHANGE_DATE: {
			return {
				...state,
				timeRange: action.payload,
			}
		}
		case SYSTEM_EVENTS_LOGBOOK_ACTION_TYPES.LOGBOOK_GET_EVENTS: {
			return {
				...state,
				events: action.payload,
			}
		}
		case SYSTEM_EVENTS_LOGBOOK_ACTION_TYPES.LOGBOOK_SET_FILTER: {
			const newFilter = [...state.filter, action.payload]

			return {
				...state,
				filter: newFilter,
			}
		}

		case SYSTEM_EVENTS_LOGBOOK_ACTION_TYPES.LOGBOOK_REMOVE_FILTER: {
			const newFilter = state.filter.filter(
				item => item !== action.payload
			)

			return {
				...state,
				filter: newFilter,
			}
		}
		default: {
			return state
		}
	}
}
